import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b7f8258"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "paginated-list-view" }
const _hoisted_2 = {
  key: 0,
  class: "search-row"
}
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = ["disabled", "onClick"]
const _hoisted_5 = {
  key: 1,
  class: "options"
}
const _hoisted_6 = {
  class: "btn-group btn-group-sm",
  role: "group",
  "aria-label": "Sort order"
}
const _hoisted_7 = ["id", "value"]
const _hoisted_8 = ["for"]
const _hoisted_9 = { class: "list-unstyled results" }
const _hoisted_10 = { class: "grid-row header-row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-cell text-end" }, "#", -1))
const _hoisted_12 = {
  key: 0,
  class: "grid-row loading"
}
const _hoisted_13 = { class: "grid-cell" }
const _hoisted_14 = { class: "grid-cell rownum" }
const _hoisted_15 = { class: "list-unstyled pages" }
const _hoisted_16 = ["disabled", "onClick"]
const _hoisted_17 = ["disabled"]

import { computed, onMounted, ref, watch, type Ref } from 'vue'
import { PaginatedList } from './Api'
import { AsyncUtil } from './AsyncUtil'
import LoadingIndicator from './LoadingIndicator.vue'

interface SortOption {
  value: string
  label: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PaginatedListView',
  props: {
    fetchPage: { type: Function },
    getRowKey: { type: Function },
    sortOptions: {},
    searchPlaceholder: {},
    showSearch: { type: Boolean },
    pageSize: {}
  },
  emits: ["sortChanged"],
  setup(__props: any, { emit }) {

const props = __props;





const loadingRef = ref(false)
const searchTextRef = ref('')
const sortRef = ref(props.sortOptions?.at(0)?.value)
const pagesRef = ref([]) as Ref<PaginatedList<any>[]>
const pageIndexRef = ref(0)

const pageRef = computed(() => pagesRef.value.at(pageIndexRef.value))
const startRowIndexRef = computed(() => pagesRef.value.slice(0, pageIndexRef.value).reduce((acc, p) => acc + p.items.length, 0))
const trimmedSearchTextRef = computed(() => searchTextRef.value.trim())
const searchTextValidRef = computed(() => trimmedSearchTextRef.value == '' || trimmedSearchTextRef.value.length > 2)

onMounted(() => {
  if (props.sortOptions?.length) sortRef.value = props.sortOptions[0].value
  reloadAsync()
})

watch([sortRef], () => reloadAsync()) // add other settings that should trigger reload

watch(sortRef, () => emit('sortChanged', sortRef.value))

async function reloadAsync() {
  pagesRef.value = [] // clear results
  pagesRef.value = [await loadPageAsync()]
  pageIndexRef.value = 0
}

async function nextPageAsync() {
  const nextToken = pageRef.value?.nextPageToken
  if (nextToken) {
    const newIndex = pageIndexRef.value + 1
    if (newIndex === pagesRef.value.length) {
      const newPage = await loadPageAsync(nextToken)
      pagesRef.value.push(newPage)
    }
    pageIndexRef.value = newIndex
  }
}

async function loadPageAsync(nextToken?: string) {
  try {
    loadingRef.value = true
    const searchText = searchTextValidRef.value ? trimmedSearchTextRef.value : undefined
    return await props.fetchPage({ search: searchText, sort: sortRef.value, next: nextToken, pageSize: props.pageSize ?? 25 })
  }
  finally {
    loadingRef.value = false
  }
}

function goToPage(i: number) {
  pageIndexRef.value = i
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showSearch)
      ? (_openBlock(), _createElementBlock("form", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTextRef).value = $event)),
            class: "form-control form-control-sm",
            placeholder: _ctx.searchPlaceholder
          }, null, 8, _hoisted_3), [
            [_vModelText, searchTextRef.value]
          ]),
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary btn-sm",
            disabled: !searchTextValidRef.value,
            onClick: _withModifiers(reloadAsync, ["prevent"])
          }, "Search", 8, _hoisted_4)
        ]))
      : _createCommentVNode("", true),
    (_ctx.sortOptions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortOptions, (s) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: s.value
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  class: "btn-check",
                  name: "sort",
                  id: 'sort' + s.value,
                  autocomplete: "off",
                  value: s.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((sortRef).value = $event))
                }, null, 8, _hoisted_7), [
                  [_vModelRadio, sortRef.value]
                ]),
                _createElementVNode("label", {
                  class: "btn btn-outline-secondary",
                  for: 'sort' + s.value
                }, _toDisplayString(s.label), 9, _hoisted_8)
              ], 64))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("ul", _hoisted_9, [
      _createElementVNode("li", _hoisted_10, [
        _hoisted_11,
        _renderSlot(_ctx.$slots, "header")
      ]),
      (loadingRef.value && !pagesRef.value.length)
        ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(LoadingIndicator)
            ])
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageRef.value?.items, (item, i) => {
        return (_openBlock(), _createElementBlock("li", {
          key: _ctx.getRowKey(item, i),
          class: "grid-row"
        }, [
          _createElementVNode("div", _hoisted_14, _toDisplayString(startRowIndexRef.value + i + 1), 1),
          _renderSlot(_ctx.$slots, "row", { item: item })
        ]))
      }), 128))
    ]),
    _createElementVNode("ul", _hoisted_15, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pagesRef.value, (p, i) => {
        return (_openBlock(), _createElementBlock("li", { key: i }, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-primary btn-sm",
            disabled: pageIndexRef.value === i,
            onClick: ($event: any) => (goToPage(i))
          }, _toDisplayString(i + 1), 9, _hoisted_16)
        ]))
      }), 128)),
      _createElementVNode("li", null, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary btn-sm",
          disabled: !pageRef.value?.nextPageToken,
          onClick: nextPageAsync
        }, "Next", 8, _hoisted_17)
      ])
    ])
  ]))
}
}

})